export enum UserApiPaths {
  Users = '/users',
  Email = '/users/email',
  Groups = '/groups',
  Roles = '/roles',
}
